import { PrismicRichText } from '@prismicio/react';
import { FC, ReactNode } from 'react';
import { RichTextField } from '@prismicio/client';

interface StatItemProps {
  item: Record<string, unknown>;
}

const renderContent = (content: unknown): ReactNode => {
  if (Array.isArray(content) && content.length > 0) {
    return <PrismicRichText field={content as RichTextField} />;
  }
  if (typeof content === 'string' || typeof content === 'number') {
    return content;
  }
  if (content) {
    return String(content);
  }
  return null;
};

const StatItem: FC<StatItemProps> = ({ item }) => {
  const metric = item.metric;
  const metricLabel = item.metric_label;
  const description =
    item.description || item.metric_description || item.stat_description;

  const renderedDescription = renderContent(description);

  return (
    <div
      className="rounded-[24px] px-6 py-4 flex flex-col items-center text-center"
      style={{ background: 'rgba(10, 39, 34, 0.80)' }}
    >
      <div className="flex items-center gap-2 text-white">
        <span className="text-[22px] md:text-[28px] font-extrabold leading-none">
          {renderContent(metric)}
        </span>
        <span className="text-sm text-gray-200">
          {renderContent(metricLabel)}
        </span>
      </div>

      {renderedDescription && (
        <div className="text-xs text-gray-300 max-w-[180px] leading-relaxed mt-2">
          {renderedDescription}
        </div>
      )}
    </div>
  );
};

export default StatItem;
